import loadable from "@loadable/component";
import { Remote } from "../../../../core/components/remote/Remote.component";
import type { FeedResultFragment } from "@ihr-radioedit/inferno-webapi";
import { coastMediaService } from "../../../../core/services/PWS";
import CoastFeedTonightShowItem from "./CoastFeedTonightShowItem.component";

const CoastShowPlaceholder = loadable(() => import("../CoastShowPlaceholder.component"));

interface CoastFeedTonightShowsLoaderProps {
    content: FeedResultFragment[] | null;
    title: string;
}

const CoastFeedTonightShowsLoader = ({ content, title }: CoastFeedTonightShowsLoaderProps) => {
    if (!content?.length) {
        return <CoastShowPlaceholder />;
    }

    // we select might more shows for this block, but we only wanna show the last one
    const show = content[content.length - 1];

    return (
        <Remote
            loader={() => coastMediaService.getOnAirStatus()}
            cacheKey={`coast-on-air-status`}
            showLoading={true}
            fallback={<CoastFeedTonightShowItem title={title} isShowLive={false} item={show} />}
        >
            {({ data }) => <CoastFeedTonightShowItem title={title} isShowLive={!!data?.isOnAir} item={show} />}
        </Remote>
    );
};

export default CoastFeedTonightShowsLoader;
